module.exports = __webpack_public_path__ + "media/images/covers/sw-thumb-01-b41c344c063d7546ab36bfc99062e3e2.jpg";